<!-- @format -->
<template>
    <div class="partner-invite-widget">
        <div class="widget-header">
            <h3>Invite a Partner</h3>
            <div class="svg-container widget-close-button" @click="closeWidget">
                <widget-close-svg />
            </div>
        </div>
        <div class="content-wrapper">
            <div>
                <div class="description">
                    <label>
                        If the partner already has a GlassHive account, invite by GlassHive Company
                        ID:
                    </label>
                </div>
                <div class="drop-down-menu">
                    <div class="input-container">
                        <app-input v-model="clientInviteId" placeholder="GlassHive Company ID" />
                        <div class="action-container">
                            <app-button @click="inviteClientById"> Invite </app-button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="widget-footer">
            <div class="cancel-container">
                <app-button class="cancel-btn transparent-btn" @click="closeWidget">
                    Cancel
                </app-button>
            </div>
        </div>
    </div>
</template>

<script>
const AppButton = () => import('@/components/common/app-button.vue');
const WidgetCloseSvg = () => import('@/components/svg/quick-add/widget-close-svg.vue');
const AppInput = () => import('@/components/common/app-input');

import EventBus from '@/scripts/event-bus.js';

export default {
    name: 'partner-invite-widget',

    components: {
        'app-button': AppButton,
        'widget-close-svg': WidgetCloseSvg,
        'app-input': AppInput,
    },

    props: {
        widget: {
            type: Object,
            required: true,
        },
    },

    data() {
        return {
            clientInviteId: null,
            clientInviteEmail: '',
        };
    },

    computed: {
        agencyBaseUrl() {
            return this.$store.getters.agencyBaseUrl;
        },

        agencyId() {
            return this.$store.state.context.agency.id;
        }
    },

    methods: {
        closeWidget() {
            EventBus.$emit('close-widget', this.widget);
        },

        inviteClientByEmail() {
            var request = {
                AgencyId: this.widget.agencyId,
                Email: this.clientInviteEmail,
            };

            this.$api
                .post(`/api/AgencyClients/Invite`, request)
                .then(() => {
                    EventBus.$emit('agency-client:update');
                    this.$helpers.showSuccessNotification('Partner successfully invited.');
                    this.closeWidget();
                })
                .catch((error) => {
                    this.$helpers.showFailNotification('An error occurred while inviting.', { error });
                });
        },

        inviteClientById() {
            var request = {
                AgencyId: this.widget.agencyId,
                UserId: this.$store.state.user.id,
                ClientId: this.clientInviteId,
            };

            this.$api
                .post(`/api/AgencyClients/Invite`, request)
                .then(() => {

                    EventBus.$emit('show-notification', {
                        iconUrl: require('@/assets/images/SVG/checkmark.svg'),
                        isIconSvg: true,
                        message: 'Partner invited!',
                        actionLabel: 'View',
                            action: () => {
                                this.$router.push(`${this.agencyBaseUrl}/PartnerRequests`);
                            },
                        }
                    );

                    EventBus.$emit('agency-client:update');
                    this.closeWidget();
                })
                .catch((error) => {
                    if (error.response.status === 409) {
                        this.$helpers.showFailNotification(
                            'The partner you are trying to invite has already been invited!',
                            { error },
                        );
                    } else {
                        this.$helpers.showFailNotification(
                            'An error occurred while inviting this partner.',
                            { error },
                        );
                    }
                });
        },
    },
};
</script>

<style>
.partner-invite-widget .or-container {
    text-align: center;
    width: 100%;
    position: relative;
    padding: 50px;
}

.partner-invite-widget .or-container::before {
    content: '';
    position: absolute;
    top: calc(50% - 1px);
    left: 0;
    width: 100%;
    height: 2px;
    border-radius: 10px;
    background: #f4f4f7;
    z-index: -1;
}

.partner-invite-widget .or-container span {
    font-size: 20px;
    font-weight: 900;
    color: #877d88;
    padding: 5px;
    background: #ffffff;
}
.partner-invite-widget .cancel-btn {
    background: transparent;

    color: #877d88;

    border: none;
}

.partner-invite-widget .cancel-btn:hover {
    background: #e1e0e5;
}

.partner-invite-widget .content-wrapper .description {
    margin-bottom: 30px;
}

.partner-invite-widget .content-wrapper .description label {
    display: block;
    font: 500 16px/1em 'Roboto';
    margin-bottom: 0.5em;
    color: #382153;
}

.partner-invite-widget .app-input {
    width: 503px;
}

.partner-invite-widget .input-container {
    display: flex;
}

.partner-invite-widget .input-container .action-container {
    margin-left: 20px;
}
</style>
